const getYolaApiUrl = (rootState) => rootState.config.service.common['public-api-gateway'].url;

export default getYolaApiUrl;
